module.exports = __webpack_public_path__ + "2dfdc308656581897d75c8f57f4539d7.png";